import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const bookmarksApi = createApi({
  reducerPath: 'bookmarks',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/bookmarks/',
  }),
  tagTypes: ['all-bookmarks'],
  endpoints: (builder) => ({
    getBookmarks: builder.query<any, void>({
      query() {
        return {
          url: `/get-bookmarks`,
          method: 'GET',
        };
      },
      providesTags: ['all-bookmarks'],
    }),
    deleteBookmark: builder.mutation<void, any>({
      query({ bookmarkId }) {
        return {
          url: `/delete-bookmarks`,
          method: 'DELETE',
          body: {
            bookmarkId: bookmarkId,
          },
        };
      },
      invalidatesTags: ['all-bookmarks'],
    }),
  }),
});

export default bookmarksApi;
